import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Tag,
    Space,
    DatePicker,
    Select,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
// import Highlighter from 'react-highlight-words';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { UploadOutlined, ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
const Search = Input.Search;
const { Option } = Select;
const { RangePicker } = DatePicker;
function Transaction() {
    const [searchText, setSearchText] = useState("");
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

    const [searchedColumn, setSearchedColumn] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [selected, setSelected] = useState();
    const debouncedSearchText = useDebounce(searchText, 300);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [psychologist, setPsychologist] = useState();
    const [expathy, setExpathy] = useState();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsExpathy, setSelectedOptionsExpathy] = useState([]);
    const [userList, setUserList] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [selectedType, setSelectedType] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const searchInput = useRef(null);
    const { confirm } = Modal;

    const [listExport, setListExport] = useState([]);

    const handleExport = () => {
        const data =
            listExport &&
            listExport.length > 0 &&
            listExport.map((row) => ({
                "Transaction ID": row.transactionId,
                Customer: row ? (row.customer ? row.customer.name : "") : "",
                "Amount ($)": row ? row.amount : "",
                "Payment Date": new Date(row.created_at).toLocaleDateString(),
            }));

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction Data");
        XLSX.writeFile(
            workbook,
            `${moment().milliseconds() +
            1000 * (moment().seconds() + 60 * 60) +
            "-transactions"
            }.xlsx`
        );
    };
    const onSearch = (e) => {
        setSearchText(e.target.value);
        setPagination({ current: 1 });
    };

    const columns = [
        {
            title: "Transaction ID",
            render: (_, { transactionId }) => {
                return <div>{transactionId ? transactionId : "---"}</div>;
            },
        },
        {
            title: "Transaction Date",
            render: (_, { created_at }) => {
                return (
                    <div>
                        {created_at ? moment(created_at).format("YYYY-MM-DD") : "---"}
                    </div>
                );
            },
        },
        {
            title: "Transaction Time",
            render: (_, { created_at }) => {
                return (
                    <div>{created_at ? moment(created_at).format("HH:mm") : "---"}</div>
                );
            },
        },
        {
            title: "Customer",
            render: (_, { customer }) => {
                return <div>{customer ? customer.name : "---"}</div>;
            },
        },
        {
            title: "Customer Email",
            render: (_, { customer }) => {
                return <div>{customer ? customer.email : "---"}</div>;
            },
        },
        {
            title: "Driver",
            render: (_, { driver }) => {
                return <div>{driver ? driver.name : "---"}</div>;
            },
        },
        {
            title: "Driver Email",
            render: (_, { driver }) => {
                return <div>{driver ? driver.email : "---"}</div>;
            },
        },
        {
            title: "Car Type",
            render: (_, { carType }) => {
                return <div>{carType ? carType.name : "--"}</div>;
            },
        },


        {
            title: "Amount ($)",
            render: (_, { amount }) => {
                return <div>{amount ? amount : 0}</div>;
            },
        },

        {
            title: "Payment Status",
            render: (_, { paymentStatus }) => {
                return <div>{paymentStatus ? paymentStatus : "--"}</div>;
            },
        },


    ];
    useEffect(() => {
        request({
            url: `/common/type-list`,
            method: "GET",
            onSuccess: (data) => {
                console.log(data, "data");
                setLoading(false);
                setTypeList(data.data.data);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    }, []);

    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [
        refresh,
        debouncedSearchText,
        startDate,
        endDate,
        selectedDriver,
        selectedCustomer,
        selectedType
    ]);

    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_active : null;

        request({
            url: `/admin/transaction/list?status=${filterActive ? filterActive.join(",") : ""
                }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
                }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
                }&end_date=${endDate ? endDate : ""
                }&driver=${selectedDriver}&customer=${selectedCustomer}&carType=${selectedType}`,
            method: "GET",
            onSuccess: (data) => {
                setLoading(false);
                // ShowToast(data.message, Severty.SUCCESS)
                setList(data.data.list.docs);
                setPagination((prev) => ({
                    current: pagination.current,
                    total: data.data.list.totalDocs,
                }));
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const handleChange = (pagination, filters) => {
        console.log(pagination, filters);
        fetchData(pagination, filters);
    };
    const handleChangeDate = (e) => {
        setStartDate();
        setEndDate();
        if (e && e.length > 0) {
            setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
            setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
        }
    };

    const handleChangeType = (values) => {
        setSelectedType(values)
    }
    const handleChangeDriver = (values) => {
        setSelectedDriver(values)
    }
    const handleChangeCustomer = (values) => {
        setSelectedCustomer(values)
    }




    useEffect(() => {
        request({
            url: `/common/user-list/User`,
            method: 'PUT',
            onSuccess: (data) => {
                // console.log(data.data.data)
                setUserList(data.data.data)
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }, []);
    useEffect(() => {
        request({
            url: `/common/user-list/Driver`,
            method: 'PUT',
            onSuccess: (data) => {
                // console.log(data.data.data)
                setDriverList(data.data.data)
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }, []);



    return (
        <Main>
            <div className="tabled">
                <Row>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Transaction Management"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        value={searchText}
                                        onPressEnter={onSearch}
                                    />
                                    <Select
                                        style={{
                                            width: "50%",
                                        }}
                                        className="select-show-inn"
                                        placeholder="Select Car Type"
                                        mode="multiple"
                                        onChange={handleChangeType}
                                    >
                                        {typeList.length > 0 && typeList.map((item) =>
                                        (
                                            <Option key={item._id} value={item._id}>
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Select
                                        style={{
                                            width: "50%",
                                        }}
                                        placeholder="Select Customer"
                                        mode="multiple"
                                        onChange={handleChangeCustomer}
                                    >
                                        {userList.length > 0 && userList.map((item) =>
                                        (
                                            <Option key={item._id} value={item._id}>
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Select
                                        style={{
                                            width: "50%",
                                        }}
                                        placeholder="Select Driver"
                                        mode="multiple"
                                        onChange={handleChangeDriver}
                                    >
                                        {driverList.length > 0 && driverList.map((item) =>
                                        (
                                            <Option key={item._id} value={item._id}>
                                                {item.name}
                                            </Option>
                                        ))}
                                    </Select>


                                    <RangePicker onChange={handleChangeDate} />
                                    {/* <Button
                                        type="primary"
                                        icon={<ExportOutlined />}
                                        onClick={handleExport}
                                    >
                                        Export
                                    </Button> */}
                                    {/* <Button onClick={(e) => setVisible(true)}>Add Transaction</Button> */}
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={pagination}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Main>
    );
}

export default Transaction;
